import React from "react";
import styles from "./winter.module.css";
import winterImage from "../../assets/images/winter.jpg";

const Winter = () => {

    return (

        <div className={styles.cameraWrapper}>
            <img className={styles.centeredImage} src={winterImage} alt="winter" />
        </div>
    );
}
export default Winter;
